import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    libros: []
  },
  mutations: {
    setLibros (state, value) {
      state.libros = value
    }
  },
  getters: {
    getLibros (state) {
      return state.libros
    }
  },
  actions: {
  },
  modules: {
  }
})
